import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App.tsx";
import i18n from "./i18n";
import { initPlausible } from "./utils/plausible";
import { initSentry } from "./utils/sentry";

initSentry();
void initPlausible();

import "./assets/fonts/fonts.css";
import "./index.css";

document.title = i18n.t("app.title");

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
